export default __webpack_public_path__ + "static/media/myLocation.ff902024.svg";